module.exports = __webpack_public_path__ + "static/media/insideout-logo-licht-zonder-slogan.3a137f17.svg";